import {Fragment, PureComponent} from 'react'

import DefaultLayout from '../../../../Layout/DefaultLayout.jsx'
import Navbar from '../../../../Navbar/Navbar.jsx'
import LoadedFreelance from '../../../../../components/Freelance/Component/LoadedFreelance/LoadedFreelance.jsx'

export default class UserProfile extends PureComponent {

  renderUserProfile = () => {
    const {currentUser, profile, showSidebarMenu, ...rest} = this.props
    return (
      <div className="bg-gray-50 print-no-color">
        <div className="container container-profile-freelance">
          <div className="row">
            <div className="mx-auto col freelance-profile print-no-border">
              <LoadedFreelance
                {...rest}
                user={profile.user}
                freelance={profile.freelance}
                profile={profile}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
  render() {
    const {wrapWithLayout} = this.props

    if(wrapWithLayout) {
      return <DefaultLayout showSidebarMenu={true} navbar={this.props.navbar ? <Navbar locked={true} /> : null}>
        {this.renderUserProfile()}
      </DefaultLayout>
    }

    return <Fragment>
      {this.renderUserProfile()}
    </Fragment>
  }
}
